import { render, staticRenderFns } from "./RegistrationHistory.vue?vue&type=template&id=a2ec7c98&scoped=true&"
import script from "./RegistrationHistory.vue?vue&type=script&lang=js&"
export * from "./RegistrationHistory.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationHistory.vue?vue&type=style&index=0&id=a2ec7c98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ec7c98",
  null
  
)

export default component.exports